import { render } from "./StorylineSerializer.vue?vue&type=template&id=10c6c2c3"
import script from "./StorylineSerializer.vue?vue&type=script&lang=js"
export * from "./StorylineSerializer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__